import { IDictionary } from '../interfaces/dictionary.interface';

export type ButtonSize = 'regular' | 'large' | 'small';
// eslint-disable-next-line
export const ButtonSize = {
    small: 'small',
    regular: 'regular',
    large: 'large',
} as IDictionary<ButtonSize>;
